
import { defineComponent } from 'vue';

export default defineComponent({
    name: "ButtonComponent",

    props: ["type", "status", "text", "disabled", "loading"],
})
